let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dF0It")).then(() => parcelRequire('4oW6C'));